import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        permissionRaporList : [],
    },
    getters: {
        getPermissionRaporList: state => state.permissionRaporList
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setPermissionRaporList(state, { resp }){
            if (resp) {
                state.permissionRaporList = resp.data.data
            }else{
                state.permissionRaporList = [{}]
            }
        },
    },
    actions: {
        getPermissionRaporList({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/permissionrapor?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setPermissionRaporList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        ProcessPermissionRapor({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/permissionrapor/set-permission?token='+Cookies.get("token"),
                        data: form,
                        isMultiple: '0',
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
